import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Grid,
  Container,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useNavigate } from "react-router-dom";

export default function CreateAreaProject() {
  const [formData, setFormData] = useState({
    project_name: "",
    project_description: "",
    location: "",
    area_covered: "",
    area_manager: "",
    total_project_cost: "",
    expected_carbon_yield: "",
  });

  const [areaManagers, setAreaManagers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch the area managers
  useEffect(() => {
    api
      .get("/popmanager/get-area-managers-list/")
      .then((response) => {
        setAreaManagers(response.data); // Assuming response.data contains a list of area managers
      })
      .catch((error) => {
        console.error("Error fetching area managers:", error);
        alert("An error occurred while fetching the area managers.");
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    api
      .post("/areamanager/area-project/", formData)
      .then((response) => {
        console.log("Area Project added successfully:", response);
        alert("Project Created Successfully");
        setLoading(false);
        navigate("/area-project-list");
      })
      .catch((error) => {
        console.error("Error adding Area Project:", error);
        alert(
          error.response?.data?.error ||
            "An error occurred while adding the Area Project."
        );
        setLoading(false);
      });
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid
          container
          justify="center"
          direction="column"
          style={{ marginTop: "20px" }}
        >
          <Typography variant="h5">Add Area Project</Typography>
          <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
            <Grid item xs={12}>
              <FormControl fullWidth required>
                <InputLabel>Area Manager</InputLabel>
                <Select
                  name="area_manager"
                  value={formData.area_manager}
                  onChange={handleChange}
                  label="Area Manager"
                >
                  {areaManagers.map((manager) => (
                    <MenuItem key={manager.id} value={manager.id}>
                      {manager.full_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ marginTop: "15px" }}>
                <TextField
                  fullWidth
                  label="Project Name"
                  name="project_name"
                  value={formData.project_name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  name="project_description"
                  value={formData.description}
                  onChange={handleChange}
                  multiline
                  rows={3}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Location"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Area Covered (acres)"
                  name="area_covered"
                  value={formData.area_covered}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Total Project Cost (Rs.)"
                  name="total_project_cost"
                  value={formData.total_project_cost}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Expected Carbon Yield (MT)"
                  name="expected_carbon_yield"
                  value={formData.expected_carbon_yield}
                  onChange={handleChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Add Area Project"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Container>
    </>
  );
}
